import { useState, useEffect } from 'react';
import { Platform } from './models';

export function getBrowserLang() {
  const [lang] = window.navigator.language.split('-');

  return lang;
}

export function UseBrowserLanguage() {
  const [language, setLanguage] = useState(getBrowserLang());

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(getBrowserLang());
    };

    window.addEventListener('languagechange', handleLanguageChange);

    return () => {
      window.removeEventListener('languagechange', handleLanguageChange);
    };
  }, []);

  return language;
}

export function replaceSecondLevelDomain(initialUrl: string, domain: string): string {
  const url = new URL(initialUrl);
  const [subdomain] = url.host.split('.');

  url.host = [subdomain, domain].join('.');

  return url.toString();
}

export function getPlatformType(): Platform {
  const [, second] = new URL(window.location.href).hostname.split('.');

  if (second && Object.values(Platform).includes(second as Platform)) {
    return second as Platform;
  }

  return Platform.Default;
}

export function addQueryParams(url: string, params: Record<string, string | number | boolean>): string {
  const urlObj = new URL(url);
  
  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.set(key, String(value));
  });

  return urlObj.toString();
}

export function isDevEnvironment(): boolean {
  const [first] = window.location.hostname.split('.');

  return first.includes('pay-dev');
}

